var map = {
	"./additional-resources.de-CH.json": 1380,
	"./additional-resources.de-DE.json": 1381,
	"./additional-resources.en-CA.json": 1382,
	"./additional-resources.en-GB.json": 1383,
	"./additional-resources.en-IN.json": 1384,
	"./additional-resources.en-ME.json": 1385,
	"./additional-resources.en-US.json": 1386,
	"./additional-resources.es-EM.json": 1387,
	"./additional-resources.es-ES.json": 1388,
	"./additional-resources.fr-BE.json": 1389,
	"./additional-resources.fr-CA.json": 1390,
	"./additional-resources.fr-CH.json": 1391,
	"./additional-resources.nl-BE.json": 1392,
	"./additional-resources.nl-NL.json": 1393,
	"./additional-resources.pl-PL.json": 1394,
	"./additional-resources.pt-BR.json": 1395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1379;